<style scoped>
.custom-values-form {
  font-family: 'Inter', 'Segoe UI', Roboto, sans-serif !important;
  font-family: var(--customization_font_family) !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 2rem 1rem;
}

.form-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 800px;
  margin: 0 auto;
}

.form-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.form-header::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="1" fill="rgba(255,255,255,0.1)"/></svg>');
  animation: float 20s infinite linear;
}

@keyframes float {
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(-20px) rotate(360deg); }
}

.form-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.step-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  gap: 1rem;
  position: relative;
}

.step-indicators::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #e0e7ff, #c7d2fe, #a5b4fc);
  border-radius: 2px;
  z-index: 1;
}

.step {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 3px solid #e0e7ff;
  background: white;
  color: #6b7280;
  position: relative;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.step.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.step.finish {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-color: #10b981;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

.form-content {
  padding: 2.5rem;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
  text-align: center;
}

.page-description {
  color: #6b7280;
  text-align: center;
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.field-container {
  margin-bottom: 2rem;
  position: relative;
}

.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
  display: block;
  text-transform: none;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: stretch;
}

input, select, textarea {
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  font-family: inherit;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s ease;
  outline: none;
}

input:focus, select:focus, textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background: #fafbff;
}

input.invalid {
  border-color: #ef4444;
  background-color: #fef2f2;
}

.prefix-addon, .suffix-addon {
  background: #f3f4f6;
  border: 2px solid #e5e7eb;
  padding: 1rem 1.25rem;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.prefix-addon {
  border-right: none;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.suffix-addon {
  border-left: none;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

.info-button {
  position: absolute;
  right: -45px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.info-button:hover {
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.color-input-group {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.color-picker {
  width: 80px;
  height: 50px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.color-text {
  flex: 1;
  height: 50px;
}

.radio-group, .checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.radio-item, .checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.radio-item:hover, .checkbox-item:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.radio-item.selected, .checkbox-item.selected {
  background: #eff6ff;
  border-color: #667eea;
  color: #1e40af;
}

.radio-item input, .checkbox-item input {
  width: auto;
  margin: 0;
}

.multiselect-wrapper {
  position: relative;
}

textarea.textarea-field {
  min-height: 120px;
  resize: vertical;
  font-family: inherit;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2.5rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.btn {
  padding: 0.875rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  border: 2px solid;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  outline: none;
}

.btn-secondary {
  background: white;
  color: #6b7280;
  border-color: #d1d5db;
}

.btn-secondary:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #9ca3af;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tooltip {
  position: absolute;
  right: -280px;
  top: 0;
  width: 250px;
  background: #1f2937;
  color: white;
  padding: 1rem;
  border-radius: 12px;
  font-size: 0.875rem;
  line-height: 1.4;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  transform: scale(0);
  transform-origin: left center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
}

.tooltip::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 8px 8px 0;
  border-color: transparent #1f2937 transparent transparent;
}

.tooltip.show {
  transform: scale(1);
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #6b7280;
}

.empty-state h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #f59e0b;
}

.tab {
  display: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .custom-values-form {
    padding: 1rem 0.5rem;
  }
  
  .form-title {
    font-size: 1.8rem;
  }
  
  .step-indicators {
    padding: 1.5rem 0;
    gap: 0.5rem;
  }
  
  .step {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  
  .form-content {
    padding: 2rem 1.5rem;
  }
  
  .navigation-buttons {
    padding: 1.5rem;
    flex-direction: column;
    gap: 1rem;
  }
  
  .tooltip {
    right: -200px;
    width: 180px;
  }
  
  .info-button {
    right: -40px;
    width: 32px;
    height: 32px;
  }
}

/* Animations */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.field-container {
  animation: slideInUp 0.3s ease-out;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .form-container {
    background: rgba(17, 24, 39, 0.95);
    border-color: rgba(55, 65, 81, 0.3);
  }
  
  .field-label {
    color: #f3f4f6;
  }
  
  input, select, textarea {
    background: #374151;
    border-color: #4b5563;
    color: #f3f4f6;
  }
  
  input:focus, select:focus, textarea:focus {
    background: #4b5563;
  }
  
  .page-title {
    color: #f3f4f6;
  }
  
  .page-description {
    color: #d1d5db;
  }
}
</style>
<template>
  <div v-if="pages.length > 0" 
    :style="{ 
        '--customization_custom_background': customization.custom_background , 
        '--customization_custom_color': customization.custom_color,
        '--customization_font_family': customization.font_family,
        '--customization_label_font_family': customization.label_font_family,
        '--customization_label_color': customization.label_color,
        '--customization_button_border_color': customization.button_border_color,
        '--customization_button_border': customization.button_border,
      }"
    class="custom-values-form">

    <app-overlay-loader v-if="preloader" />
    
    <div class="form-container">
      <!-- Header -->
      <div class="form-header" :style="{ backgroundColor: customization.custom_background, color: customization.custom_color }">
        <h1 class="form-title">{{ formname }}</h1>
      </div>

      <!-- Step Indicators -->
      <div class="step-indicators">
        <div 
          v-for="(page, index) in pages" 
          :key="page.id"
          :class="['step', { active: currentTab === index, finish: index < currentTab }]"
          :style="{ 
            backgroundColor: currentTab === index ? customization.button_background : '',
            color: currentTab === index ? customization.button_color : '' 
          }"
          @click="showTab(index)"
          :title="replaceFieldKeysWithValues(page.name)">
          {{ index + 1 }}
        </div>
      </div>

      <form>
        <!-- Form Pages -->
        <div class="tab" v-for="(page, index) in pages" :key="page.id">
          <div class="form-content">
            <h2 class="page-title">{{ replaceFieldKeysWithValues(page.name) }}</h2>
            <div class="page-description" v-html="replaceFieldKeysWithValues(page.step_description)"></div>
            
            <div v-if="page.custom_values.length <= 0" class="empty-state">
              <h3>Custom Values Required</h3>
              <p>You need to create custom values for this account to continue.</p>
            </div>
            
            <div v-else>
              <div 
                v-for="(custom_value, val_index) in Object.values(page.custom_values)"
                :key="custom_value.id"
                class="field-container">
                
                <!-- Select Field -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'select'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <select 
                      :class="{ required: custom_value.required, invalid: false }"
                      :name="custom_value.field_name" 
                      :ref="custom_value.field_name"
                      v-model="field_values[index][val_index].value" 
                      @change="setCustomValue(field_values[index][val_index].value, custom_value)"
                      oninput='this.classList.remove("invalid")'>
                      <option disabled value="">Please select an option</option>
                      <option 
                        v-for="element in custom_value.choices.split(';')" 
                        :key="element" 
                        :value="element">
                        {{ element }}
                      </option>
                    </select>
                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- Multi-select Field -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'multi-select'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <div class="multiselect-wrapper">
                      <multiselect 
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name" 
                        :multiple="true"
                        :clear-on-select="false" 
                        :preserve-search="true" 
                        placeholder="Please select options"
                        v-model="field_values[index][val_index].value" 
                        @input="setCustomValue(field_values[index][val_index].value, custom_value)"
                        :preselect-first="false" 
                        :close-on-select="false" 
                        :options="custom_value.choices.split(';')">
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length > 0 && !isOpen">
                            {{ values.length }} options selected
                          </span>
                        </template>
                      </multiselect>
                    </div>
                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- Text/Number/Password/Date Fields -->
                <div v-if="['text', 'number', 'password', 'date'].includes(custom_value_type(custom_value.custom_field_type_id))">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <span v-if="custom_value.prefix" class="prefix-addon">
                      {{ custom_value.prefix }}
                    </span>
                    
                    <input 
                      v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)"
                      :class="{ required: custom_value.required }"
                      :type="custom_value_type(custom_value.custom_field_type_id)" 
                      :placeholder="custom_value.field_name"
                      :readonly="true" 
                      :ref="custom_value.field_name" 
                      :name="custom_value.field_name" 
                      :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )"
                      @change="setCustomValue(
                        getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        ),
                        custom_value
                      )"
                      oninput='this.classList.remove("invalid")' />

                    <input 
                      v-else
                      :class="{ required: custom_value.required }" 
                      :type="custom_value_type(custom_value.custom_field_type_id)" 
                      :placeholder="custom_value.field_name"
                      :ref="custom_value.field_name" 
                      :name="custom_value.field_name"
                      v-model="field_values[index][val_index].value" 
                      @input="setCustomValue(field_values[index][val_index].value, custom_value)"
                      oninput='this.classList.remove("invalid")' />
                      
                    <span v-if="custom_value.suffix" class="suffix-addon">
                      {{ custom_value.suffix }}
                    </span>

                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- Color Picker -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'Color picker'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <div class="color-input-group">
                      <input 
                        v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)"
                        type="color" 
                        class="color-picker" 
                        disabled 
                        :readonly="true" 
                        :ref="custom_value.field_name" 
                        :name="custom_value.field_name"
                        :value="getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        )" />
                        
                      <input 
                        v-else
                        type="color" 
                        class="color-picker" 
                        v-model="field_values[index][val_index].value" 
                        @input="setCustomValue(field_values[index][val_index].value, custom_value)" />

                      <input 
                        v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)"
                        type="text" 
                        class="color-text"
                        disabled 
                        :readonly="true" 
                        :ref="custom_value.field_name" 
                        :name="custom_value.field_name"
                        :value="getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        )" />
                        
                      <input 
                        v-else
                        type="text" 
                        class="color-text" 
                        v-model="field_values[index][val_index].value" 
                        @input="setCustomValue(field_values[index][val_index].value, custom_value)" />
                    </div>
                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- File Field -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'File'">
                  <File :custom_value="custom_value" />
                </div>

                <!-- Textarea Field -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'textarea'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <app-input 
                      v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                      custom-config
                      type="textarea"
                      class="textarea-field"
                      :removeClass="true"
                      inputClass="textarea-field"
                      :required="true"
                      :id="'textarea-id' + index + val_index"
                      :label="custom_value.field_name"
                      :class="{ required: custom_value.required }"
                      :name="custom_value.field_name" 
                      :ref="custom_value.field_name"
                      @input="setCustomValue(
                        getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        ),
                        custom_value
                      )"
                      :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )"
                      oninput='this.classList.remove("invalid")'
                      :placeholder="custom_value.field_name" />

                    <app-input 
                      v-else
                      custom-config
                      type="textarea"
                      class="textarea-field"
                      :removeClass="true"
                      inputClass="textarea-field"
                      :required="true"
                      :id="'textarea-id' + index + val_index"
                      :key="'text-editor-id' + index + val_index"
                      :label="custom_value.field_name"
                      :class="{ required: custom_value.required }"
                      :name="custom_value.field_name" 
                      :ref="custom_value.field_name"
                      v-model="field_values[index][val_index].value"
                      @input="setCustomValue(field_values[index][val_index].value, custom_value)"
                      oninput='this.classList.remove("invalid")'
                      :placeholder="custom_value.field_name" />

                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- Text Editor Field -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'text-editor'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <app-input 
                      v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                      custom-config
                      type="text-editor"
                      class="textarea-field"
                      :required="true"
                      :id="'text-editor-id' + index + val_index"
                      :label="custom_value.field_name"
                      :class="{ required: custom_value.required }"
                      :name="custom_value.field_name" 
                      :ref="custom_value.field_name"
                      @input="setCustomValue(
                        getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        ),
                        custom_value
                      )"
                      :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )"
                      oninput='this.classList.remove("invalid")'
                      :placeholder="custom_value.field_name" />

                    <app-input 
                      v-else
                      custom-config
                      type="text-editor"
                      class="textarea-field"
                      :required="true"
                      :id="'text-editor-id' + index + val_index"
                      :key="'text-editor-id' + index + val_index"
                      :label="custom_value.field_name"
                      :class="{ required: custom_value.required }"
                      :name="custom_value.field_name" 
                      :ref="custom_value.field_name"
                      v-model="field_values[index][val_index].value"
                      @input="setCustomValue(field_values[index][val_index].value, custom_value)"
                      oninput='this.classList.remove("invalid")'
                      :placeholder="custom_value.field_name" />

                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- Radio Buttons -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'radio'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <div class="radio-group">
                      <div 
                        v-for="(item, item_index) in custom_value.choices.split(';')" 
                        :key="item_index"
                        :class="['radio-item', { selected: field_values[index][val_index].value === item }]">
                        <input 
                          :class="{ required: custom_value.required }" 
                          :ref="custom_value.field_name"
                          :name="custom_value.field_name" 
                          v-model="field_values[index][val_index].value" 
                          @change="setCustomValue(field_values[index][val_index].value, custom_value)"
                          type="radio" 
                          :id="'radio' + index + val_index + item_index" 
                          :value="item"
                          oninput='this.classList.remove("invalid")'>
                        <label :for="'radio' + index + val_index + item_index">{{ item }}</label>
                      </div>
                    </div>
                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

                <!-- Checkboxes -->
                <div v-if="custom_value_type(custom_value.custom_field_type_id) === 'checkbox'">
                  <label class="field-label">{{ custom_value.field_name }}</label>
                  <div class="input-wrapper">
                    <div class="checkbox-group">
                      <!-- Single Checkbox -->
                      <div v-if="custom_value.choices.includes('#single:')" class="checkbox-item">
                        <input 
                          :class="{ required: custom_value.required }" 
                          :ref="custom_value.field_name"
                          v-model="field_values[index][val_index].value" 
                          @change="setCustomValue(field_values[index][val_index].value, custom_value)"
                          :value="custom_value.choices.replace(/#multiple:|#single:/gi, '').split(';')[0]"
                          :unchecked-value="custom_value.choices.replace(/#multiple:|#single:/gi, '').split(';')[1]"
                          type="checkbox"
                          :id="'checkbox' + index + val_index"
                          oninput='this.classList.remove("invalid")'>
                        <label :for="'checkbox' + index + val_index">{{ custom_value.field_name }}</label>
                      </div>

                      <!-- Multiple Checkboxes -->
                      <div 
                        v-if="custom_value.choices.includes('#multiple:')"
                        v-for="(item, item_index) in custom_value.choices.replace(/#multiple:|#single:/gi, '').split(';')" 
                        :key="item_index"
                        :class="['checkbox-item', { selected: field_values[index][val_index].value && field_values[index][val_index].value.includes(item) }]">
                        <input 
                          :class="{ required: custom_value.required }"
                          :ref="custom_value.field_name" 
                          v-model="field_values[index][val_index].value" 
                          @change="setCustomValue(field_values[index][val_index].value, custom_value)"
                          type="checkbox" 
                          :id="'checkbox' + index + val_index + item_index" 
                          :value="item"
                          oninput='this.classList.remove("invalid")'>
                        <label :for="'checkbox' + index + val_index + item_index">{{ item }}</label>
                      </div>
                    </div>
                    <button 
                      type="button"
                      class="info-button"
                      @click="showToolTip('#tooltip' + index + val_index)">
                      <i class="fas fa-info"></i>
                    </button>
                  </div>
                  <div class="tooltip" :id="'tooltip' + index + val_index">
                    <span v-html="custom_value.description ?? custom_value.field_name"></span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Navigation -->
        <div class="navigation-buttons">
          <button 
            :style="{ 
              backgroundColor: customization.button_background, 
              color: customization.button_color,
              borderColor: customization.button_border_color,
              borderWidth: customization.button_border + 'px'
            }" 
            class="btn btn-secondary" 
            :disabled="preloader || filePreloader" 
            type="button" 
            id="prevBtn"
            @click="nextPrev(-1)">
            <i class="fas fa-chevron-left"></i>
            Previous
          </button>
          
          <div style="display: flex; gap: 1rem;">
            <button 
              :style="{ 
                backgroundColor: customization.button_background, 
                color: customization.button_color,
                borderColor: customization.button_border_color,
                borderWidth: customization.button_border + 'px'
              }" 
              v-if="currentTab < pages.length - 1" 
              class="btn btn-primary" 
              type="button" 
              :disabled="preloader || filePreloader" 
              @click="nextPrev(1, true)">
              <i class="fas fa-save"></i>
              Save
            </button>
            
            <button  
              :style="{ 
                backgroundColor: customization.button_background, 
                color: customization.button_color,
                borderColor: customization.button_border_color,
                borderWidth: customization.button_border + 'px'
              }" 
              class="btn btn-primary" 
              type="button" 
              id="nextBtn" 
              :disabled="preloader || filePreloader"
              @click="nextPrev(1)">
              <span v-if="currentTab < pages.length - 1">
                Next
                <i class="fas fa-chevron-right"></i>
              </span>
              <span v-else>
                <i class="fas fa-check"></i>
                Save
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  
  <div v-else class="empty-state">
    <h3>Setup Required</h3>
    <p>You need to add pages and custom values to your application.</p>
    <a :href="urlGenerator('app/custom')" class="btn btn-primary">
      <i class="fas fa-plus"></i>
      Create Custom Values
    </a>
  </div>
</template>
<script>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Verte from 'verte';
import coreLibrary from "../../../../core/helpers/CoreLibrary";
import 'verte/dist/verte.css';
import Multiselect from "vue-multiselect";
import File from "./components/file.vue";

export default {
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "originalCustomValues",
    "customization",
    "formname"
  ],
  components: { Multiselect, verte: Verte, File },

  data() {
    return {
      urlGenerator,
      preloader: false,
      filePreloader: false,
      currentTab: 0,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      customValues: [],
    };
  },

  created() {
    this.reorderPage();

    this.pages.forEach((page, page_index) => {
      let data = [];
      let page_custom_values = Object.values(page.custom_values);
      page_custom_values.forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value ?? "") });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {

                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {

                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {

                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });

      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });
  },

  mounted() {
    this.showTab(0);
  },
  
  methods: {
    replaceFieldKeysWithValues(text) {
      if (!text || typeof text !== 'string') return text;

      if (this.action == "test") {
        return this.originalCustomValues.reduce((result, field) => {
          const escapedKey = this.escapeRegExp(field.fieldKey);
          return result.replace(new RegExp(escapedKey, 'g'), field.value || '');
        }, text);
      } else {
        return this.originalCustomValues.customValues.reduce((result, field) => {
          const escapedKey = this.escapeRegExp(field.fieldKey);
          return result.replace(new RegExp(escapedKey, 'g'), field.value || '');
        }, text);
      }
    },
    
    escapeRegExp(string) {
      if (!string) return '';
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    
    hasOperation(fieldKey, field_key) {
      return this.operations_index.includes(fieldKey) || this.operations_index.includes(field_key);
    },
    
    showToolTip(selector) {
      // Hide all tooltips first
      document.querySelectorAll('.tooltip').forEach(tooltip => {
        tooltip.classList.remove('show');
      });
      
      // Show the selected tooltip
      const tooltip = document.querySelector(selector);
      if (tooltip) {
        tooltip.classList.add('show');
        
        // Auto-hide after 5 seconds
        setTimeout(() => {
          tooltip.classList.remove('show');
        }, 5000);
      }
    },

    reorderPage() {
      this.pages.sort((a, b) => {
        if (a.position < b.position) return -1;
        if (a.position > b.position) return 1;
        return 0;
      });
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    showTab(n) {
      this.title = this.pages[n].name;
      var x = document.getElementsByClassName("tab");

      x[n].style.display = "block";

      if (n != this.currentTab) {
        x[this.currentTab].style.display = "none";
      }

      if (n == 0) {
        document.getElementById("prevBtn").style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }

      this.currentTab = n;
      this.fixStepIndicator(n);
    },

    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = value;
      }
    },

    getFieldOperationValue(operand1, operand2, operator, type) {
      let op1;
      let op2;

      var operand1_without_space = operand1.replace(/\s+/g, "");
      var operand2_without_space = operand2.replace(/\s+/g, "");

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } else if (this.field_index[operand1_without_space] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1_without_space]][
            this.field_index[operand1_without_space]
          ].value;
      } else {
        op1 = this.findOperationValue(operand1);
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } else if (this.field_index[operand2_without_space] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2_without_space]][
            this.field_index[operand2_without_space]
          ].value;
      } else {
        op2 = this.findOperationValue(operand2);
      }

      return this.makeOperation(type, operator, op1, op2);
    },

    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseFloat(op1);
        op2 = parseFloat(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },

    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },

    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },

    getPrefixValue(prefix) {
      if (prefix && prefix.length > 0) {
        return prefix;
      } else {
        return "";
      }
    },

    getSuffixValue(suffix) {
      if (suffix && suffix.length > 0) {
        return suffix;
      } else {
        return "";
      }
    },

    removePrefixSuffixValue(prefix, suffix, value) {
      if (typeof value !== "string") {
        return value;
      }
      if (value.startsWith(prefix) && prefix != null) {
        value = value.substr(prefix.length);
      }

      if (value.endsWith(suffix) && suffix != null) {
        value = value.substr(0, value.length - suffix.length);
      }
      return value;
    },

    findOperationValue(op) {
      if (this.field_index[op] !== undefined) {
        let op1 =
          this.field_values[this.page_index[op]][
            this.field_index[op]
          ].value;
        return op1;
      }

      let value;
      const result = Object.values(this.pages[this.currentTab].custom_values).find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value ?? '';
        }
      } else {
        value = result.value ?? '';
      }
      return value;
    },

    nextPrev(n, change = false) {
      var x = document.getElementsByClassName("tab");
      if (this.currentTab < x.length - 1 || n == -1) {
        if (n == 1 && !this.validateForm()) return false;
        else if (n == 1 && this.validateForm()) {
          this.customValues = [];

          Object.values(this.pages[this.currentTab].custom_values).forEach(
            (custom_value, val_index) => {
              const operation = this.operations.find(
                ({ result }) => result === custom_value.fieldKey
              );

              if (operation == null) {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value:
                    this.getPrefixValue(custom_value.prefix) +
                    (typeof custom_value.value == "object"
                      ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                      : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' '))) + this.getSuffixValue(custom_value.suffix),
                });
              } else {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value: this.getPrefixValue(custom_value.prefix) + this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, this.getOperationValue(operation)) + this.getSuffixValue(custom_value.suffix),
                });
              }
            }
          );

          if (this.pages.length < 2) {
            let customs = [];
            this.pages.forEach((page) => {
              customs.push(...Object.values(page.custom_values));
            });

            this.operations.forEach((operation) => {
              const result = customs.find(
                ({ fieldKey }) => fieldKey === operation.result
              );

              if (result == null) {
                this.customValues.push({
                  id: this.getOperationId(operation.result),
                  fieldKey: operation.result,
                  field_type: '',
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }
            });
          }

          if (change) {
            this.$emit("save", this.action, this.customValues, this.currentTab, n, change);
          } else {
            this.$emit("save", this.action, this.customValues, this.currentTab, n, false);
          }
        }
        if (n == -1) {
          x[this.currentTab].style.display = "none";
          this.currentTab = this.currentTab + n;
          this.showTab(this.currentTab);
        }
      } else {
        if (n == 1 && !this.validateForm()) return false;

        this.customValues = [];
        Object.values(this.pages[this.currentTab].custom_values).forEach(
          (custom_value, val_index) => {
            const operation = this.operations.find(
              ({ result }) => result === custom_value.fieldKey
            );

            if (operation == null) {
              this.customValues.push({
                id: custom_value.cv_id,
                fieldKey: custom_value.fieldKey,
                field_type: this.custom_value_type(custom_value.custom_field_type_id),
                name: custom_value.name,
                value: this.getPrefixValue(custom_value.prefix) +
                  (typeof custom_value.value == "object"
                    ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                    : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))
                  + this.getSuffixValue(custom_value.suffix),
              });
            } else {
              this.customValues.push({
                id: custom_value.cv_id,
                fieldKey: custom_value.fieldKey,
                field_type: this.custom_value_type(custom_value.custom_field_type_id),
                name: custom_value.name,
                value: this.getPrefixValue(custom_value.prefix) + this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, this.getOperationValue(operation)) + this.getSuffixValue(custom_value.suffix),
              });
            }
          }
        );

        let customs = [];
        this.pages.forEach((page) => {
          customs.push(...Object.values(page.custom_values));
        });

        this.operations.forEach((operation) => {
          const result = customs.find(
            ({ fieldKey }) => fieldKey === operation.result
          );

          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              fieldKey: operation.result,
              field_type: '',
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }
        });

        this.$emit("save", this.action, this.customValues, this.currentTab, n, true);
        return false;
      }
    },

    validateForm() {
      var x, y, i, valid = true;
      x = document.getElementsByClassName("tab");
      y = x[this.currentTab].getElementsByClassName("required");

      for (i = 0; i < y.length; i++) {
        if (y[i].value == "") {
          y[i].classList.add("invalid");
          valid = false;
        }
      }

      if (valid) {
        document.getElementsByClassName("step")[this.currentTab].className +=
          " finish";
      }
      return valid;
    },

    fixStepIndicator(n) {
      var i, x = document.getElementsByClassName("step");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      x[n].className += " active";
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/* Multiselect customization for modern theme */
.multiselect__tags {
  background-color: white !important;
  min-height: 50px !important;
  padding: 12px 40px 0 12px !important;
  outline: 0 !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.multiselect__tags:focus-within {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}

.multiselect__select {
  padding: 30px 8px;
}

.multiselect__single {
  font-weight: 500;
  color: #374151;
}

.multiselect__content {
  border: 2px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
}

.multiselect__element {
  border-radius: 8px;
  margin: 2px;
}

.multiselect__option {
  padding: 12px;
  border-radius: 8px;
  margin: 2px;
  transition: all 0.2s ease;
}
</style>
